import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { useClientLabel } from '@src/clients/hooks/useClientLabel';
import { TextInput } from '@src/common/components/TextInput';
import type { ClientOption } from '@src/permits/permitSearch/filters/ClientFilter';
import { ClientFilter } from '@src/permits/permitSearch/filters/ClientFilter';
import type { SearchPermitBasicFilters } from '@src/permits/services/PermitApplicationClient';

interface Props {
  onFilterChange: (filters: SearchPermitBasicFilters) => void;
  value: {
    name: string;
    value: string;
  }[];
  options?: ClientOption[];
}

export const OrderClientFilter = ({
  onFilterChange,
  value,
  options,
}: Props) => {
  const OrderClientInput = (params: AutocompleteRenderInputParams) => {
    const { clientLabel } = useClientLabel();
    return <TextInput {...params} label={clientLabel} />;
  };
  return (
    <ClientFilter
      onFilterChange={onFilterChange}
      value={value}
      options={options}
      renderInput={OrderClientInput}
      filterKey="client"
    />
  );
};
